import type { DevLoginRole } from '@packages/cognito-auth/react';

/**
 * Compile-time gate for the dev login bypass (see packages/cognito-auth). Vite
 * statically replaces the env read, so every dev-auth code path is dead-code
 * eliminated from builds that don't set the flag (staging/production/preview).
 */
export const DEV_AUTH_ENABLED = import.meta.env.VITE_DEV_AUTH_BYPASS === 'true';

export const devLoginRoles = [
  'superAdmin',
  'restaurantUser',
] as const satisfies readonly DevLoginRole[];
